import Vue from 'vue'
import Moment from 'moment'

Vue.filter('formatDate', function (date, format) {
  if(date){
    return Moment(date).format(format || 'LL');
  }
  return date;
});

Vue.filter('allCaps', (val) => {
  if(val)
    return val.toUpperCase();
  else
    return val;
});